import Vue from "vue";
import Router from "vue-router";
import main from "@/components/main/main";
import login from "@/components/login/login";
import noPermission from "@/components/noPermission/noPermission";

Vue.use(Router);

const router = new Router({
  // mode: "history",
  routes: [
    {
      path: "/login",
      component: login
    },
    {
      path: "/nopermission",
      component: noPermission
    },
    {
      path: "/",
      redirect: "/user",
      component: main,
      children: [
        {
          path: "/user",
          meta: { title: "权限管理", require: true },
          component: () => import("@/base/user/user")
        },
        {
          path: "/directlyCustomer",
          meta: { title: "直客列表", require: true },
          component: () => import("@/base/customer/directlyCustomer")
        },
        {
          path: "/potentialCustomer",
          meta: { title: "用户画像列表", require: true },
          component: () => import("@/base/customer/potentialCustomer")
        },
        {
          path: "/imei",
          meta: { title: "imei", require: true },
          component: () => import("@/base/customer/imei")
        },
        {
          path: "/privateCustomer",
          meta: { title: "有效列表", require: true },
          component: () => import("@/base/customer/privateCustomer")
        },
        {
          path: "/blankCustomer",
          meta: { title: "黑名单列表", require: true },
          component: () => import("@/base/customer/blankCustomer")
        },
        {
          path: "/privateCustomer/dynamic",
          meta: { title: "客户动态", require: true },
          component: () => import("@/base/customer/privateCustomerDynamic")
        },
        {
          path: "/publicCustomer",
          meta: { title: "公客列表", require: true },
          component: () => import("@/base/customer/publicCustomer")
        },
        {
          path: "/invalidCustomer",
          meta: { title: "无效列表", require: true },
          component: () => import("@/base/customer/invalidCustomer")
        },
        {
          path: "/financeManage",
          meta: { title: "财务管理", require: true },
          component: () => import("@/base/franchise/financeManage")
        },
        {
          path: "/promotion",
          meta: { title: "AI推荐词", require: true },
          component: () => import("@/base/promotion/promoteWordGenerate")
        },
        {
          path: "/franchiseManage",
          meta: { title: "加盟管理", require: true },
          component: () => import("@/base/franchise/franchiseManage")
        },
        {
          path: "/userArea",
          meta: { title: "招商经理管理", require: true },
          component: () => import("@/base/user/userArea")
        },
        {
          path: "/costManage",
          meta: { title: "开票管理", require: true },
          component: () => import("@/base/franchise/costManage")
        },
        {
          path: "/promotionManage",
          meta: { title: "费效管理", require: true },
          component: () => import("@/base/franchise/PromotionManage")
        },
        {
          path: "/dataSummary",
          meta: { title: "销售数据汇总", require: true },
          component: () => import("@/base/data/dataSummary")
        },
        {
          path: "/dataCenter",
          meta: { title: "数据中心", require: true },
          component: () => import("@/base/bigScreen/index")
        },
        {
          path: "/customerData",
          meta: { title: "数据中心", require: true },
          component: () => import("@/base/data/customerData")
        },
        {
          path: "/baidu/consumer/check",
          meta: { title: "消费核验", require: true },
          component: () => import("@/base/consumer/baiduConsumerCorrect")
        },
        {
          path: "/live",
          meta: { title: "直播", require: true },
          component: () => import("@/base/live/live")
        },
        {
          path: "/dyZhuBoUser",
          meta: { title: "抖音主播", require: true },
          component: () => import("@/base/user/dyZhuBoUser")
        },
        {
          path: "/message",
          meta: { title: "通知中心", require: true },
          component: () => import("@/base/message/CrmMessage")
        },
        {
          path: "/merchant/customer/config",
          meta: { title: "团队管理设置", require: true },
          component: () => import("@/base/customer/merchantCustomerConfig")
        },
        {
          path: "/ai/chatMessage",
          meta: { title: "AI聊天管理", require: true },
          component: () => import("@/base/ai/chatMessage")
        },
        {
          path: "/ol/trace/report",
          meta: { title: "在线埋点日报", require: true },
          component: () => import("@/base/ol/traceDailyReport")
        },
        {
          path: "/ol/account/board",
          meta: { title: "账号经营看板", require: true },
          component: () => import("@/base/ol/accountBoard")
        }
      ]
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (to.meta.require) {
    if (sessionStorage.getItem("isLogin") !== "true") {
      next({
        path: "/login",
        query: { redirect: to.fullPath } // 将跳转首页时的路由path作为参数，登录成功后跳转到该路由
      });
    }
  }
  next();
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js